module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-1-8ee6934de87ff1389b81361378a24b92.webp";